import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import store from "../store";

//============================ENGLISH=================================
import layoutEN from "./en/layout.json";
import footerEN from "./en/footer.json";
import homeEN from "./en/home.json";
import loginEN from "./en/login.json";
import registerEN from "./en/register.json";
import validationsEN from "./en/validations.json";
import alert_messagesEN from "./en/alertMessages.json";
import strategicObjectivesEN from "./en/strategicObjectives.json";
import breadCrumbsEN from "./en/breadCrumbs.json";
import dataIndicatorEN from "./en/dataIndicators.json";
import partnersEN from "./en/partners.json";
import interventionAreaEN from "./en/interventionArea.json";
import goalsEN from "./en/goals.json";
import sustainableDevelopmentGoalsEN from "./en/sustainableDevelopmentGoals.json";
import educationTrainingAndSportEN from "./en/educationTrainingAndSport.json";
import goalsOfSDGEN from "./en/goalsOfSDG.json";
import themesEN from "./en/themes.json";
import editorEN from "./en/editor.json";
import scienceTechnologyInnovationEN from "./en/scienceTechnologyInnovation.json";
import governanceEN from "./en/governance.json";
import economyEN from "./en/economy.json";
import protectionAndSafeguardEN from "./en/protectionAndSafeguard.json";
import marineEnviromentEN from "./en/marineEnviroment.json";
import livingResourcesEN from "./en/livingResources.json";
import nonLivingResourcesEN from "./en/nonLivingResources.json";
import searchCommonEN from "./en/searchCommon.json";
import infrastructureServiceActivitiesEN from "./en/infrastructureServiceActivities.json";
import tourismrecreationAndCultureEN from "./en/tourismRecreationAndCulture.json";
import megaMenuEN from "./en/megaMenu.json";
import aboutUsEN from "./en/aboutUs.json";
import legalNoticesEN from "./en/legalNotices.json";
import dataProtectionEN from "./en/dataProtection.json";
import subCardEN from "./en/subCard.json";
import contactUsEN from "./en/contactUs.json";
import siteMapEN from "./en/siteMap.json";
import floatingHelperEN from "./en/floatingHelper.json";
import managePartnerEN from "./en/managePartner.json";
import myDashboardEN from "./en/myDashboard.json";
import dashboardEditorEN from "./en/dashboardEditor.json";
import manageIndicatorEN from "./en/manageIndicator.json";
import manageThemeEN from "./en/manageTheme.json";
import managePoliciesEN from "./en/managePolicies.json";
import manageUsersEN from "./en/manageUsers.json";
import PartnerPageEN from "./en/partnerPage.json";
import myAnalysisBoardEN from "./en/myAnalysisBoard.json";
import filtersByEN from "./en/filtersBy.json";
import errorSectionEN from "./en/errorSection.json";
import dropZoneEN from "./en/dropZone.json";
import formSwitchLanguageEN from "./en/formSwitchLanguage.json";
import statusEN from "./en/status.json";
import modelTemplateIndicatorEN from "./en/modelTemplateIndicator.json";
import itemsPerPageSelectorEN from "./en/itemsPerPageSelector.json";
import confirmDataImportEN from "./en/confirmDataImport.json";
import captchaEN from "./en/captcha.json";
//============================PORTUGUESE==============================
import layoutPT from "./pt/layout.json";
import footerPT from "./pt/footer.json";
import homePT from "./pt/home.json";
import loginPT from "./pt/login.json";
import registerPT from "./pt/register.json";
import validationsPT from "./pt/validations.json";
import alert_messagesPT from "./pt/alertMessages.json";
import strategicObjectivesPT from "./pt/strategicObjectives.json";
import breadCrumbsPT from "./pt/breadCrumbs.json";
import dataIndicatorPT from "./pt/dataIndicators.json";
import partnersPT from "./pt/partners.json";
import interventionAreaPT from "./pt/interventionArea.json";
import goalsPT from "./pt/goals.json";
import sustainableDevelopmentGoalsPT from "./pt/sustainableDevelopmentGoals.json";
import educationTrainingAndSportPT from "./pt/educationTrainingAndSport.json";
import goalsOfSDGPT from "./pt/goalsOfSDG.json";
import themesPT from "./pt/themes.json";
import editorPT from "./pt/editor.json";
import scienceTechnologyInnovationPT from "./pt/scienceTechnologyInnovation.json";
import governancePT from "./pt/governance.json";
import economyPT from "./pt/economy.json";
import protectionAndSafeguardPT from "./pt/protectionAndSafeguard.json";
import marineEnviromentPT from "./pt/marineEnviroment.json";
import livingResourcesPT from "./pt/livingResources.json";
import nonLivingResourcesPT from "./pt/nonLivingResources.json";
import searchCommonPT from "./pt/searchCommon.json";
import infrastructureServiceActivitiesPT from "./pt/infrastructureServiceActivities.json";
import tourismrecreationAndCulturePT from "./pt/tourismRecreationAndCulture.json";
import megaMenuPT from "./pt/megaMenu.json";
import aboutUsPT from "./pt/aboutUs.json";
import legalNoticesPT from "./pt/legalNotices.json";
import dataProtectionPT from "./pt/dataProtection.json";
import subCardPT from "./pt/subCard.json";
import contactUsPT from "./pt/contactUs.json";
import siteMapPT from "./pt/siteMap.json";
import floatingHelperPT from "./pt/floatingHelper.json";
import managePartnerPT from "./pt/managePartner.json";
import myDashboardPT from "./pt/myDashboard.json";
import dashboardEditorPT from "./pt/dashboardEditor.json";
import manageIndicatorPT from "./pt/manageIndicator.json";
import manageThemePT from "./pt/manageTheme.json";
import managePoliciesPT from "./pt/managePolicies.json";
import manageUsersPT from "./pt/manageUsers.json";
import PartnerPagePT from "./pt/partnerPage.json";
import myAnalysisBoardPT from "./pt/myAnalysisBoard.json";
import filtersByPT from "./pt/filtersBy.json";
import errorSectionPT from "./pt/errorSection.json";
import dropZonePT from "./pt/dropZone.json";
import formSwitchLanguagePT from "./pt/formSwitchLanguage.json";
import statusPT from "./pt/status.json";
import modelTemplateIndicatorPT from "./pt/modelTemplateIndicator.json";
import itemsPerPageSelectorPT from "./pt/itemsPerPageSelector.json";
import confirmDataImportPT from "./pt/confirmDataImport.json";
import captchaPT from "./pt/captcha.json";

var allDataEN = {};
var allDataPT = {};

for (const iterator of [
    layoutEN,
    footerEN,
    homeEN,
    loginEN,
    registerEN,
    validationsEN,
    alert_messagesEN,
    strategicObjectivesEN,
    breadCrumbsEN,
    dataIndicatorEN,
    partnersEN,
    interventionAreaEN,
    goalsEN,
    sustainableDevelopmentGoalsEN,
    educationTrainingAndSportEN,
    goalsOfSDGEN,
    themesEN,
    editorEN,
    scienceTechnologyInnovationEN,
    governanceEN,
    economyEN,
    protectionAndSafeguardEN,
    marineEnviromentEN,
    livingResourcesEN,
    nonLivingResourcesEN,
    searchCommonEN,
    infrastructureServiceActivitiesEN,
    tourismrecreationAndCultureEN,
    megaMenuEN,
    aboutUsEN,
    legalNoticesEN,
    dataProtectionEN,
    subCardEN,
    contactUsEN,
    siteMapEN,
    floatingHelperEN,
    managePartnerEN,
    myDashboardEN,
    dashboardEditorEN,
    manageIndicatorEN,
    manageThemeEN,
    managePoliciesEN,
    manageUsersEN,
    PartnerPageEN,
    myAnalysisBoardEN,
    filtersByEN,
    errorSectionEN,
    dropZoneEN,
    formSwitchLanguageEN,
    statusEN,
    modelTemplateIndicatorEN,
    itemsPerPageSelectorEN,
    confirmDataImportEN,
    captchaEN,
]) {
    for (let key of Object.keys(iterator)) {
        allDataEN[key] = iterator[key];
    }
}

for (const iterator of [
    layoutPT,
    footerPT,
    homePT,
    loginPT,
    registerPT,
    validationsPT,
    alert_messagesPT,
    strategicObjectivesPT,
    breadCrumbsPT,
    dataIndicatorPT,
    partnersPT,
    interventionAreaPT,
    goalsPT,
    sustainableDevelopmentGoalsPT,
    educationTrainingAndSportPT,
    goalsOfSDGPT,
    themesPT,
    editorPT,
    scienceTechnologyInnovationPT,
    governancePT,
    economyPT,
    protectionAndSafeguardPT,
    marineEnviromentPT,
    livingResourcesPT,
    nonLivingResourcesPT,
    searchCommonPT,
    infrastructureServiceActivitiesPT,
    tourismrecreationAndCulturePT,
    megaMenuPT,
    aboutUsPT,
    legalNoticesPT,
    dataProtectionPT,
    subCardPT,
    contactUsPT,
    siteMapPT,
    floatingHelperPT,
    managePartnerPT,
    myDashboardPT,
    dashboardEditorPT,
    manageIndicatorPT,
    manageThemePT,
    managePoliciesPT,
    manageUsersPT,
    PartnerPagePT,
    myAnalysisBoardPT,
    filtersByPT,
    errorSectionPT,
    dropZonePT,
    formSwitchLanguagePT,
    statusPT,
    modelTemplateIndicatorPT,
    itemsPerPageSelectorPT,
    confirmDataImportPT,
    captchaPT,
]) {
    for (let key of Object.keys(iterator)) {
        allDataPT[key] = iterator[key];
    }
}

const resources = {
    lenguaje_eng: {
        translation: allDataEN,
    },
    lenguaje_ptl: {
        translation: allDataPT,
    },
};

i18n
    // Enables the hook initialization module
    .use(initReactI18next)
    .init({
        // Standard language used
        fallbackLng: store.getState().globalStore.language,
        resources,
        // detection: {
        //     order: ["queryString", "cookie"],
        //     cache: ["cookie"],
        // },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
